// extracted by mini-css-extract-plugin
export default {"welcome-block":"styles_welcome-block__zFoF5","welcome-block__content":"styles_welcome-block__content__JB3Um"};